/**
 * Fetches the SVG content from the given URL.
 * @param url - The URL of the SVG image.
 * @returns A promise that resolves to the SVG content as a string.
 */
import { apiCall } from './api';

export const fetchMultipleSvgs = async (urls: [string]) => {
  try {
    // Make a request to the URL
    return urls.map(async url => {
      await fetchSvgContent(url);
    });
  } catch (error) {
    console.log('Error fetching SVGs:', error);
  }
};

export const fetchSvgContent = async function (url: string): Promise<string> {
  try {
    // Make a request to the URL
    const response = await fetch(url);

    // Check if the response is OK (status code 200-299)
    if (!response.ok) {
      throw new Error(`Failed to fetch SVG: ${url} ${response.statusText}`);
    }

    // Get the SVG content as text
    const svgContent = await response.text();

    return svgContent;
  } catch (error) {
    console.error('Error fetching SVG content:', error);
    throw error;
  }
};

/**
 * Given an SVG content string, loads the SVG image as an HTMLImageElement.
 * @param svg - The SVG content as a string.
 * @returns  A promise that resolves to the SVG image as an HTMLImageElement.
 */
export const loadSvgImage = async (svg: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    img.onload = () => resolve(img);
    img.onerror = reject;
  });
};
